
export const completedTaskFields = [
    {name: 'Name',            key: 'name',             type: 'text' },
    {name: 'Date',            key: 'date',             type: 'date' },
    {name: 'Counter',         key: 'counter',          type: 'number' },
    {name: 'Description',     key: 'description',      type: 'text' },
    // Multi-line: see the Notes comment in LogbookTypes.mjs. Maintenance
    // entries map these fields in with storage: 'column' added.
    {name: 'Notes',           key: 'notes',            type: 'textarea', rows: 5 },
    {name: 'Price',           key: 'cost',             type: 'number', step: 'any' },
    {name: 'Done By',         key: 'fixByEmail',       type: 'text' },
    {name: 'Was due counter', key: 'dueCounter',       type: 'number' },
    {name: "Counter Based On",key: "itemCounterId",    type: "select" },
    {name: 'Was due date',    key: 'dueDate',          type: 'date' },
    {name: 'Counter Interval',key: 'counterInterval',  type: 'number' },
    {name: 'Interval',        key: 'daysInterval',     type: 'interval', monthsKey: 'monthsInterval' }
];
